import React, { Fragment, useMemo, useState } from 'react';
import { getMenuComponent } from './functions';
import { useChangesHistoryContext } from '../context';
import { ChevronDown, ChevronRight } from "../../../../dashboard/layouts/dashboard/sidebar/icons/icons/icons";


const ThemeSettingsItem = ({ open, schemaValuesKey, onOpen, schemaValues }) => {
  const {
    currentState: { settings },
    onChangeThemeSettings,
    themeCacheId,
  } = useChangesHistoryContext();

  const [recentlySelectedColors, setRecentlySelectedColors] = useState([]);

  const currentlyUsedColors = useMemo(() => {
    return Array.from(
      new Set(Object.values(settings?.properties?.[schemaValuesKey])),
    );
  }, [settings?.properties?.[schemaValuesKey]]);

  const handleChange = (id, newValue, isNewColor = true) => {
    isNewColor &&
      setRecentlySelectedColors(prevColors => [...prevColors, newValue]);

    onChangeThemeSettings(schemaValuesKey, id, newValue, themeCacheId);
  };

  const renderComponent = schemaValue => {
    const props = {
      ...schemaValue,
      onChange: handleChange,
      initialValue: settings?.properties?.[schemaValuesKey]?.[schemaValue?.id],
      recentlySelectedColors,
      currentlyUsedColors,
    };

    return getMenuComponent(schemaValue, props);
  };

  return (
    <>
      <div className="visual-menu-settings-header" style={open ? { border: "none" } : {}} onClick={() => onOpen(schemaValuesKey)}>
        <div className="visual-menu-icon mr-2">{open ? <ChevronDown /> : <ChevronRight />}</div>
        {schemaValuesKey.replace('_', ' ')}
      </div>

      {open && (
        <div className="visual-menu-settings-content">
          {schemaValues?.map((schemaValue, idx) => (
            <Fragment key={idx}>{renderComponent(schemaValue)}</Fragment>
          ))}
        </div>
      )}
    </>
  );
};

export default ThemeSettingsItem;
